module.exports = __webpack_public_path__ + "img/no.f15f0324.svg";